// You can customize the template with the help of this file

// Template config options
const themeConfig = {
  app: {
    appName: 'MyCynergy',
    // eslint-disable-next-line @typescript-eslint/no-var-requires,global-require
    appLogoImage: require('../assets/images/logo/logo.png')
  },
  font: 'Inter',
  company: {
    llc: 'Open Lab Solutions, Inc.',
    TagLine: 'Bridging the gap between innovation and patient care since 2018.',
    address: '7780 E. 106 ST.',
    city: 'Tulsa',
    state: 'OK',
    zip: '74133',
    email: 'info@cynergysuite.io',
    phone: '(918) 310-2200',
    fax: '(918) 310-2201',
    hours: 'M-F 8:00AM-5:00PM',
    parentCompanyUrl: 'https://www.openlabsolutions.com/portal/'
  },
  layout: {
    isRTL: false,
    skin: 'light', // light, dark, bordered, semi-dark
    routerTransition: 'fadeIn', // fadeIn, fadeInLeft, zoomIn, none or check this for more transition
    // https://animate.style/
    type: 'horizontal', // vertical, horizontal
    contentWidth: 'boxed', // full, boxed
    menu: {
      isHidden: true,
      isCollapsed: true
    },
    navbar: {
      // ? For horizontal menu, navbar type will work for navMenu type
      type: 'floating', // static , sticky , floating, hidden
      backgroundColor: 'white' // BS color options [primary, success, etc]
    },
    footer: {
      type: 'static' // static, sticky, hidden
    },
    customizer: false,
    scrollTop: true // Enable scroll to top button
  },
  // Palette mirrors the SCSS tokens in
  // src/_base/@core/scss/base/bootstrap-extended/_variables.scss
  // Used by PDF rendering, Apex charts, and any non-SCSS styling surface.
  palette: {
    primary: {
      main: 'rgba(25, 58, 98)',
      light: 'rgba(25, 58, 98, 0.12)'
    },
    secondary: {
      main: 'rgba(107, 122, 153)',
      light: 'rgba(107, 122, 153, 0.12)'
    },
    accent: {
      main: 'rgba(232, 116, 97)',
      light: 'rgba(232, 116, 97, 0.12)'
    },
    success: {
      main: 'rgba(22, 163, 74)',
      light: 'rgba(22, 163, 74, 0.12)'
    },
    danger: {
      main: 'rgba(220, 38, 38)',
      light: 'rgba(220, 38, 38, 0.12)'
    },
    warning: {
      main: 'rgba(217, 119, 6)',
      light: 'rgba(217, 119, 6, 0.12)'
    },
    info: {
      main: 'rgba(59, 130, 246)',
      light: 'rgba(59, 130, 246, 0.12)'
    },
    light: {
      main: 'rgba(248, 250, 251)',
      light: 'rgba(248, 250, 251, 0.5)'
    },
    dark: {
      main: 'rgba(29, 41, 57)',
      light: 'rgba(29, 41, 57, 0.12)'
    },
    muted: {
      main: 'rgba(152, 162, 179)',
      light: 'rgba(152, 162, 179, 0.12)'
    },
    body: {
      main: 'rgba(71, 84, 103)',
      light: 'rgba(71, 84, 103, 0.12)'
    },
    text: {
      main: 'rgba(16, 24, 40)',
      light: 'rgba(16, 24, 40, 0.12)'
    },
    electric: {
      main: 'rgba(115, 103, 240)',
      light: 'rgba(115, 103, 240, 0.12)'
    },
    border: {
      main: 'rgba(228, 231, 236)',
      light: 'rgba(228, 231, 236, 0.5)'
    }
  }
};

export default themeConfig;
